export const formatDuration = (durationInSeconds) => {
    if (durationInSeconds === undefined || durationInSeconds === null) return '00:00:00';

    const totalSeconds = Math.floor(durationInSeconds);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
    ].join(':');
};

export const formatDateTime = (date) => {
    if (!date) return null;

    try {
        let parsedDate;

        if (typeof date === 'string') {
            const dateStr = date.endsWith('Z') ? date : date + 'Z';
            parsedDate = new Date(dateStr);
        } else if (date instanceof Date) {
            parsedDate = date;
        } else {
            return null;
        }

        if (!isNaN(parsedDate.getTime())) {
            return parsedDate.toLocaleString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }

        return null;
    } catch (e) {
        console.error('Ошибка форматирования даты:', e);
        return null;
    }
};

export const formatRecordingTime = (seconds) => {
    const totalSeconds = Math.floor(seconds);
    if (totalSeconds < 3600) {
        const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
        const secs = (totalSeconds % 60).toString().padStart(2, '0');
        return `${minutes}:${secs}`;
    }
    return formatDuration(seconds);
};